export enum LoadingIndicatorSize {
  SMALL = 'small',
  LARGE = 'large',
}
